<div class="side-navigation">
    <div class="side-navigation-wrapper">
        <a
            class="main-node {{ gtmPrefix }}-side-navigation-node selenium-side-navigation-node"
            [attr.data-gtmlabel]="navigationNode.title"
            [ngClass]="{ 'active-node': isActive() }"
            [routerLink]="navigationNode.getRouterLink()"
            [ngStyle]="getColor()"
        >
            <span>{{ navigationNode.title }}</span>
        </a>
        <app-side-navigation-nodes
            [childrenNodes]="navigationNode.children"
            [activeNode]="activeNode"
            [styles]="styles"
            [gtmPrefix]="gtmPrefix"
            [firstLevel]="true"
        >
        </app-side-navigation-nodes>
    </div>
</div>
